/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_EngineInputs */

const en_home_spec_engine = /** @type {(inputs: Home_Spec_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engine`)
};

/**
* | output |
* | --- |
* | "Engine" |
*
* @param {Home_Spec_EngineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_engine = /** @type {((inputs?: Home_Spec_EngineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_EngineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_engine(inputs)
});
export { home_spec_engine as "home.spec.engine" }